import useSWR, { SWRResponse } from "swr";
import type { Card } from "@memento/types/card";
import { useAuthenticatedFetcher, getLoadingStatus } from "src/libs/fetcher";
import { getContributorCardsEndpointUrl } from "src/libs/api-endpoint-lib";

export const useContributorCards = (enabledFetch = true) => {
  const fetcher = useAuthenticatedFetcher();
  const key = enabledFetch ? getContributorCardsEndpointUrl() : null;

  const { data, error, mutate }: SWRResponse<Card[], Error> = useSWR(
    key,
    (url: string) => fetcher(url)
  );

  return {
    cards: data || null,
    error,
    status: getLoadingStatus(key, data, error),
    mutate,
  };
};
